import type { CSSProperties } from 'react';
import { skillBars, skills } from '../data/content';
import { SectionHead } from './primitives';

export function Skills() {
  return (
    <section className="section" id="skills" aria-labelledby="skills-title">
      <div className="container">
        <SectionHead title="Skills" id="skills-title" />

        <div className="skills">
          {/* One reveal target for the whole list so the bars fill together,
              the way they did when the old jQuery version hit the viewport. */}
          <ul className="bars" data-reveal>
            {skillBars.map((skill, i) => (
              <li key={skill.name}>
                <div className="bar__head">
                  <h3 className="bar__name">{skill.name}</h3>
                  <span className="bar__note">{skill.note}</span>
                </div>
                <div className="bar__track">
                  <span
                    className="bar__fill"
                    style={
                      { '--level': `${skill.level}%`, '--delay': `${i * 90}ms` } as CSSProperties
                    }
                  />
                </div>
              </li>
            ))}
          </ul>

          <div className="groups" data-reveal>
            {skills.map((group) => (
              <div key={group.label}>
                <h3 className="group__label">{group.label}</h3>
                <ul className="group__items">
                  {group.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
